export default "__VITE_ASSET__CqTf26cl__"